import api from 'api'
import { get } from 'lodash'
import { CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    createBeneficialOwnerContact: build.mutation({
      query: ({ accountId, ...rest }) => ({
        url: `/api/v1/core/accounts/${accountId}/beneficial-owner-contacts`,
        method: 'POST',
        body: { ...rest },
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST],
    }),
    updateBeneficialOwnerContact: build.mutation({
      query: ({ accountId, id, ...rest }) => ({
        url: `/api/v1/core/accounts/${accountId}/beneficial-owner-contacts/${id}`,
        method: 'PUT',
        body: { ...rest },
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST],
    }),
    patchBeneficialOwnerContact: build.mutation({
      query: ({ accountId, id, ...rest }) => ({
        url: `/api/v1/core/accounts/${accountId}/beneficial-owner-contacts/${id}`,
        method: 'PATCH',
        body: { ...rest },
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST],
    }),
    deleteBeneficialOwnerContact: build.mutation({
      query: ({ accountId, id, ...rest }) => ({
        url: `/api/v1/core/accounts/${accountId}/beneficial-owner-contacts/${id}`,
        method: 'DELETE',
        body: { ...rest },
      }),
      invalidatesTags: [CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST],
    }),
    fetchBeneficialOwnerContactDetails: build.query({
      query: ({ accountId, id }) => ({
        url: `/api/v1/core/accounts/${accountId}/beneficial-owner-contacts/${id}`,
      }),
      providesTags: [CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST],
    }),
    fetchBeneficialOwnerContacts: build.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/accounts/${accountId}/beneficial-owner-contacts`,
      }),
      providesTags: [CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST],
    }),
    getOverridingBeneficialOwnerContact: build.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/accounts/${accountId}/beneficial-owner-contacts`,
      }),
      providesTags: [CACHE_TAG_ACCOUNT_BENEFICIAL_OWNER_LIST],
      transformResponse: response => {
        const beneficialOwnerContactList = get(response, 'beneficialOwnerContacts', [])
        return beneficialOwnerContactList.find(contact => {
          return get(contact, 'beneficialOwnerOverride', false)
        })
      },
    }),
  }),
})

export const {
  useCreateBeneficialOwnerContactMutation,
  useUpdateBeneficialOwnerContactMutation,
  usePatchBeneficialOwnerContactMutation,
  useDeleteBeneficialOwnerContactMutation,
  useLazyFetchBeneficialOwnerContactDetailsQuery,
  useLazyFetchBeneficialOwnerContactsQuery,
  useLazyGetOverridingBeneficialOwnerContactQuery,
} = extendedApi
